import { getObjectUtil } from 'packages/src'
import { REDUX_STATUS } from '../../constants'

function isLoadingReduxSelector (path) {
  return state => getObjectUtil(state, `${path}.status`) === REDUX_STATUS.LOADING
}

export default isLoadingReduxSelector
